import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { PurchaseInvoice, SalesInvoice } from '@tcc-mono/vandijk/shared/data-access/models';
import { PurchaseInvoiceService, SalesInvoiceService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';
import { Observable, map, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PurchaseInvoiceRepository extends CoreRepository<PurchaseInvoice> {

  public constructor(
    protected readonly _purchaseInvoiceService: PurchaseInvoiceService
  ) {
    super(
      { name: 'salesInvoices' },
      _purchaseInvoiceService
    );
  }

  public exportToExact = (invoiceId: number): Observable<PurchaseInvoice> => {
    return this._purchaseInvoiceService.sendToExact(invoiceId)
      .pipe(
        map(({ data }) => data),
        tap((invoice) => this.addEntitiesInStore([invoice]))
      );
  }
}
